import apiClient, { safeJson } from '@/api/client';
import {
    CoachCommissionTableResponse,
    GetCoachCommissionTableParams,
    PatchCoachCommissionTableBody,
    ExceptionSaveFormat,
    PutCoachExceptionRatesBody,
    PutCoachExceptionRatesResponse,
} from './types';
import { toPutCoachExceptionRatesRequest } from './exceptionRules';

/**
 * @method get
 * @brief 강사 급여테이블 조회
 */
export const getCoachCommissionTables = async ({ centerId, year, month }: GetCoachCommissionTableParams) => {
    const res = await apiClient.get(`v1/coachCommissionTables/center/${centerId}`, {
        searchParams: { year, month },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachCommissionTableResponse | null,
    };
};

/**
 * @method patch
 * @brief 강사 급여테이블 설정 (upsert)
 */
export const patchCoachCommissionTables = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PatchCoachCommissionTableBody;
}) => {
    const res = await apiClient.patch(`v1/coachCommissionTables/center/${centerId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as CoachCommissionTableResponse | null,
    };
};

/**
 * @method put
 * @brief 예외 수업료 저장 전용 — 강사 1명·월 1개 단위.
 *
 * 기존 요율 PATCH(전원 전송)에는 exceptionRates 를 싣지 않는다(서버가 400).
 * `[]` 는 「이 달부터 예외 없음」. 실패는 throw(err.status / err.body.errorCode).
 */
export const putCoachExceptionRates = async ({
    centerId,
    body,
    format = 'v2',
}: {
    centerId: string;
    body: PutCoachExceptionRatesBody;
    /** 'legacy' = 이전 서버(exceptionRatesAllModes 없음) — 예전 형식 그대로 보낸다. 'v3' = inMultiplier 를 아는 서버. */
    format?: ExceptionSaveFormat;
}) => {
    const res = await apiClient.put(`v1/coachCommissionTables/center/${centerId}/exception-rates`, {
        json: toPutCoachExceptionRatesRequest(body, format),
        // 정산 분류 기능의 요청은 401 자동 갱신·재전송을 끈다(다른 탭의 새 로그인 토큰을 덮어쓰지 않게).
        noAuthRetry: true,
    } as any);
    return (await safeJson(res)) as PutCoachExceptionRatesResponse | null;
};
